import React from "react";
import { Link } from "react-router-dom";

export const LiveBadge = () => (
  <span className="fx ac gap8 mono" style={{ fontSize: 11, color: "#059669" }}>
    <span className="dot-live" />
    LIVE
  </span>
);

const ProjectCard = ({ p }) => (
  <div className="card col stag" style={{ padding: 28 }}>
    <div className="fx jb ac mb16">
      <span className="mono" style={{ fontSize: 12, fontWeight: 600, color: "var(--accent)" }}>
        {p.num}
      </span>
      {p.live && <LiveBadge />}
    </div>
    <h3 style={{ fontSize: 18, fontWeight: 600, margin: "0 0 8px" }}>{p.title}</h3>
    <p className="f1" style={{ fontSize: 14, lineHeight: 1.65, color: "var(--muted)", margin: "0 0 18px" }}>
      {p.desc}
    </p>
    <div className="fx wrap gap8 mb16">
      {p.tech.map((t) => (
        <span key={t} className="tag">
          {t}
        </span>
      ))}
    </div>
    <div className="fx ac gap16">
      {p.caseStudy && (
        <Link to={p.caseStudy} className="mono fw6" style={{ fontSize: 12.5 }}>
          case_study →
        </Link>
      )}
      {p.liveUrl && (
        <a href={p.liveUrl} className="mono fw6" style={{ fontSize: 12.5 }} target="_blank" rel="noreferrer">
          live ↗
        </a>
      )}
    </div>
  </div>
);

export default ProjectCard;
